
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "width": "17px",
    "height": "17px",
    "viewBox": "0 0 17 17",
    "enable-background": "new 0 0 17 17",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "首页",
        "transform": "translate(-1110 -664)"
      },
      "children": [
        {
          "tag": "polyline",
          "attrsMap": {
            "id": "矩形_3_1_",
            "fill": "none",
            "points": "1127,681 1110,681 1110,664 \t"
          }
        },
        {
          "tag": "g",
          "attrsMap": {
            "id": "首页-2",
            "transform": "translate(1109.949 549.288)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_1",
                "fill": "#FFFFFF",
                "d": "M16.578,125.071c-0.135,0-0.264-0.058-0.354-0.158l-7.1-7.98\n\t\t\tc-0.146-0.173-0.361-0.274-0.587-0.277l0,0c-0.227,0.003-0.44,0.105-0.587,0.278l-7.081,7.98c-0.173,0.194-0.471,0.212-0.667,0.04\n\t\t\tc-0.195-0.174-0.212-0.473-0.04-0.667l7.08-7.98c0.324-0.378,0.795-0.597,1.293-0.6l0,0c0.497,0.001,0.967,0.218,1.292,0.594\n\t\t\tl7.101,7.979c0.173,0.195,0.155,0.494-0.04,0.667c-0.086,0.076-0.197,0.118-0.313,0.118L16.578,125.071z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_2",
                "fill": "#FFFFFF",
                "d": "M14.203,124.173v4.723c0,0.521-0.422,0.944-0.943,0.944h-1.887v-3.774\n\t\t\tc-0.002-1.042-0.846-1.887-1.887-1.888H7.599c-1.042,0.001-1.886,0.846-1.887,1.888v3.774H3.825\n\t\t\tc-0.521-0.001-0.943-0.423-0.944-0.944v-4.718H1.937v4.718c0.001,1.042,0.846,1.887,1.887,1.888h2.835v-4.718\n\t\t\tc0-0.521,0.423-0.943,0.944-0.944H9.49c0.521,0,0.943,0.423,0.943,0.944v4.718h2.825c1.042-0.001,1.886-0.846,1.887-1.888v-4.718\n\t\t\tL14.203,124.173z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  